const useCurrentPageProp = { currentPage: { type: Number } };
const createItemsProp = () => ({
  items: { type: Array, default: () => [] }
});
const useSelectableProp = { selectable: { type: Boolean, default: false } };
const useItemsTrackByProp = { itemsTrackBy: { type: [String, Function], default: "" } };
export {
  useItemsTrackByProp as a,
  useSelectableProp as b,
  createItemsProp as c,
  useCurrentPageProp as u
};
//# sourceMappingURL=useCommonProps.js.map
